import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Bottles, Calendar, Charger, MyLocation, StarWhite } from '../../../assests/ExportImageIcon'
import { BUS_RESULT } from '../busList/BusResults'
import './busBookingDetail.css'

// Static placeholder — no bus booking API exists yet, so sidebar fare/coupons and the
// onboarding/drop point block below are hardcoded to match the reference design exactly.
// Sidebar (Important Information / Fare Breakup / Offers & Discounts) and the Traveller
// Details / Contact Details / Passenger Details accordion reuse the exact same
// .bookingSidebar/.bsSection/.travellerDetail/.travellerField classes as
// cruiseAllBookingDetails/cruiseBookingDetail.jsx (same design, no new CSS for these).
const IMPORTANT_INFO = [
    'Check-in begins 2 hours before departure',
    'Carry a valid government ID proof',
    'Web check-in available 48 hours before departure',
    "Baggage subject to airline's baggage policy",
]

const COUPONS = [
    { code: 'GIRUSH', off: '₹ 312 off', desc: 'Use this coupon and get ₹ 312 instant discount on your flight booking.' },
    { code: 'GIRUSH', off: '₹ 312 off', desc: 'Use this coupon and get ₹ 312 instant discount on your flight booking.' },
    { code: 'GIRUSH', off: '₹ 312 off', desc: 'Use this coupon and get ₹ 312 instant discount on your flight booking.' },
    { code: 'GIRUSH', off: '₹ 312 off', desc: 'Use this coupon and get ₹ 312 instant discount on your flight booking.' },
]

const BOARDING_POINT = {
    address: 'ISBT Kashmiri Gate Inside Arrival Platform Near 53 & 54',
    time: '30 Apr • 06:30 PM',
}

const DROP_POINT = {
    address: 'ISBT Kashmiri Gate Inside Arrival Platform Near 53 & 54',
    time: '30 Apr • 07:00 AM',
}

const CONTACT_DEFAULT = { email: 'shubhammodi820@gmail.com', mobile: '9024250272' }

const PASSENGER_SEATS = ['C4', 'C3']

const PASSENGER_DEFAULT = { firstName: '', lastName: '', mobile: '', gender: 'Male', nationality: '', dob: '' }

const BusBookingDetail = () => {
    const navigate = useNavigate()
    const [travellerOpen, setTravellerOpen] = useState(true)
    const [contact, setContact] = useState(CONTACT_DEFAULT)
    const [passengers, setPassengers] = useState(() => PASSENGER_SEATS.map(() => ({ ...PASSENGER_DEFAULT })))

    const updatePassenger = (index, field, value) => {
        setPassengers((prev) => prev.map((passenger, i) => (i === index ? { ...passenger, [field]: value } : passenger)))
    }

    return (
        <>
            <section className='flightBookingDetails commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='allBookingDetail'>
                                <div className='allBokkingInfo'>

                                    <div className='resultCard'>
                                        <div className='resultCard__main'>
                                            <div className='resultCard__airline'>
                                                <div>
                                                    <div className='resultCard__airlineName'>{BUS_RESULT.operator}</div>
                                                    <div className='resultCard__flightNo'>{BUS_RESULT.busType}</div>
                                                </div>
                                            </div>
                                            <div className='resultCard__time'>
                                                <div className='resultCard__timeValue'>{BUS_RESULT.departureTime}</div>
                                            </div>
                                            <div className='resultCard__duration'>
                                                <div className='resultCard__durationValue'>{BUS_RESULT.duration}</div>
                                                <div className='busResultCard__seatsInfo'>{BUS_RESULT.seatsLeft} Seats Left • {BUS_RESULT.windows} Windows</div>
                                            </div>
                                            <div className='resultCard__time'>
                                                <div className='resultCard__timeValue'>{BUS_RESULT.arrivalTime}</div>
                                            </div>
                                            <div className='resultCard__price'>
                                                <div className='resultCard__priceValue'>{BUS_RESULT.price}</div>
                                            </div>
                                        </div>

                                        <div className='busResultCard__metaRow'>
                                            <div className='busResultCard__rating'>
                                                <span className='hotelCard__ratingBadge'>
                                                    <img src={StarWhite} alt="" /> {BUS_RESULT.rating}
                                                </span>
                                                <span className='busResultCard__reviews'>({BUS_RESULT.reviews})</span>
                                            </div>
                                            <div className='busResultCard__amenities'>
                                                <img src={Charger} alt="" />
                                                <img src={MyLocation} alt="" />
                                                <img src={Bottles} alt="" />
                                            </div>
                                        </div>

                                        <div className='resultCard__footer'>
                                            <div className={`resultCard__refundTag ${BUS_RESULT.onTime ? 'resultCard__refundTag--yes' : 'resultCard__refundTag--no'}`}>
                                                {BUS_RESULT.onTime ? 'On Time' : 'Delayed'}
                                            </div>
                                        </div>

                                        <div className='bookingSegmentBox bookingInfoRow'>
                                            <div>
                                                <div className='bookingInfoLabel'>Onboarding Point:</div>
                                                <div className='bookingInfoDate busBookingDetail__pointAddress'>{BOARDING_POINT.address}</div>
                                                <div className='bookingInfoTime'>{BOARDING_POINT.time}</div>
                                            </div>
                                            <div className='text-end'>
                                                <div className='bookingInfoLabel'>Drop Point:</div>
                                                <div className='bookingInfoDate busBookingDetail__pointAddress'>{DROP_POINT.address}</div>
                                                <div className='bookingInfoTime'>{DROP_POINT.time}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='travellerDetail'>
                                        <div className='fareDetailsHead' onClick={() => setTravellerOpen(!travellerOpen)}>
                                            <div className='bsSectionTitle'>Traveller Details</div>
                                            <span className={`fareCollapseIcon ${travellerOpen ? 'open' : ''}`}>&#8963;</span>
                                        </div>

                                        {travellerOpen && (
                                            <div className='fareDetailsBody'>
                                                <div className='bsSectionTitle'>Contact Details</div>
                                                <div className='bsBox'>
                                                    <div className='travellerFieldRow'>
                                                        <div className='travellerField'>
                                                            <label>Email Address</label>
                                                            <input type='email' value={contact.email} onChange={(e) => setContact({ ...contact, email: e.target.value })} />
                                                        </div>
                                                        <div className='travellerField'>
                                                            <label>Mobile Number</label>
                                                            <input
                                                                type='tel'
                                                                inputMode='numeric'
                                                                maxLength={10}
                                                                value={contact.mobile}
                                                                onChange={(e) => setContact({ ...contact, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <p className='travellerFieldNote'>Booking confirmation will be sent here</p>
                                                </div>

                                                <div className='bsSectionTitle mt-3'>Passenger Details</div>
                                                {passengers.map((passenger, index) => (
                                                    <div className='bsBox mt-3' key={index}>
                                                        <div className='travellerPassengerHead'>
                                                            <span>Passenger {index + 1}</span>
                                                            <span className='busBookingDetail__seatBadge'>{PASSENGER_SEATS[index]}</span>
                                                        </div>
                                                        <div className='travellerFieldRow'>
                                                            <div className='travellerField'>
                                                                <label>First/Middle Name</label>
                                                                <input type='text' value={passenger.firstName} onChange={(e) => updatePassenger(index, 'firstName', e.target.value)} />
                                                            </div>
                                                            <div className='travellerField'>
                                                                <label>Last Name</label>
                                                                <input type='text' value={passenger.lastName} onChange={(e) => updatePassenger(index, 'lastName', e.target.value)} />
                                                            </div>
                                                            <div className='travellerField'>
                                                                <label>Mobile Number (Optional)</label>
                                                                <input
                                                                    type='tel'
                                                                    inputMode='numeric'
                                                                    maxLength={10}
                                                                    value={passenger.mobile}
                                                                    onChange={(e) => updatePassenger(index, 'mobile', e.target.value.replace(/\D/g, '').slice(0, 10))}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='travellerFieldRow'>
                                                            <div className='travellerField'>
                                                                <label>Gender</label>
                                                                <select value={passenger.gender} onChange={(e) => updatePassenger(index, 'gender', e.target.value)}>
                                                                    <option>Male</option>
                                                                    <option>Female</option>
                                                                    <option>Other</option>
                                                                </select>
                                                            </div>
                                                            <div className='travellerField'>
                                                                <label>Nationality</label>
                                                                <select value={passenger.nationality} onChange={(e) => updatePassenger(index, 'nationality', e.target.value)}>
                                                                    <option value='' disabled>Select</option>
                                                                    <option>Indian</option>
                                                                    <option>Other</option>
                                                                </select>
                                                            </div>
                                                            <div className='travellerField'>
                                                                <label>Date Of Birth (DOB)</label>
                                                                <div style={{ position: 'relative' }}>
                                                                    <input
                                                                        type='date'
                                                                        value={passenger.dob}
                                                                        onChange={(e) => updatePassenger(index, 'dob', e.target.value)}
                                                                        style={{ paddingRight: 24 }}
                                                                    />
                                                                    <img src={Calendar} alt="" style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div className='totalPay bgWhite paddingCommon20 borderRadius20 commonBorder'>
                                        <button type='button' className='commonBtn w-100' onClick={() => navigate('/bus-payment')}>
                                            Pay ₹4,549
                                        </button>
                                        <p className='bsFareNote totalPayNote'>By proceeding, you agree to our Terms &amp; Conditions</p>
                                    </div>
                                </div>

                                <div className='bookingSidebar'>
                                    <div className='bsSection'>
                                        <div className='bsSectionTitle'>Important Information</div>
                                        <div className='bsBox'>
                                            <ul className='bsInfoList'>
                                                {IMPORTANT_INFO.map((info, index) => (
                                                    <li key={index}>{info}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='bsSection'>
                                        <div className='bsSectionTitle'>Fare Breakup (1 Adult)</div>
                                        <div className='bsBox'>
                                            <div className='bsFareRow'>
                                                <span>Base Fare</span>
                                                <span>₹3,599</span>
                                            </div>
                                            <div className='bsFareRow'>
                                                <span>Taxes &amp; Fees</span>
                                                <span>₹450</span>
                                            </div>
                                            <div className='bsFareDivider' />
                                            <div className='bsFareRow'>
                                                <span>Sub-total</span>
                                                <span>₹4,049</span>
                                            </div>
                                            <div className='bsFareRow'>
                                                <span>Convenience Fee</span>
                                                <span>₹250</span>
                                            </div>
                                            <div className='bsFareDivider' />
                                            <div className='bsFareRow bsFareRow--total'>
                                                <span>TOTAL AMOUNT</span>
                                                <span>₹4,299</span>
                                            </div>
                                            <p className='bsFareNote'>
                                                Convenience fee is charged for payment processing and platform services. Seat selection charges (if any) will be added during seat selection.
                                            </p>
                                        </div>
                                    </div>

                                    <div className='bsSection'>
                                        <div className='bsSectionTitle'>Offers &amp; Discounts</div>
                                        <div className='bsBox'>
                                            <input type='text' className='bsCouponInput' placeholder='Enter coupon code' />
                                            {COUPONS.map((coupon, index) => (
                                                <div className='bsCouponCard' key={index}>
                                                    <div className='bsCouponHead'>
                                                        <span className='bsCouponCode'>{coupon.code}</span>
                                                        <span className='bsCouponOff'>{coupon.off}</span>
                                                    </div>
                                                    <p className='bsCouponDesc'>{coupon.desc}</p>
                                                    <button type='button' className='bsCouponApply'>APPLY COUPON</button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BusBookingDetail
